import React from 'react'

const ScreenHeader: React.FC<{title?: string, description?: string , className?: string}> = ({
    title= '',
    description= '',
    className = '',
}) => {
  return (
    <div className={`w-full  mb-8 ${className}`}>
    <div className="container mx-auto text-center px-4">
      <h1 className="text-xl md:text-3xl font-bold text-gray-900 mb-2">{title}</h1>
      {description && (
        <p className="text-palette-text text-md">{description}</p>
      )}
    </div>
  </div>
  )
}

export default ScreenHeader
